// extracted by mini-css-extract-plugin
export default {"root":"SelectPricelistForm__root___mk4uj"};